import React from "react";
import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "./home/motionPresets";

const SectionHeader = ({ eyebrow, title, lead }) => (
  <motion.div
    className="section__header"
    initial="hidden"
    whileInView="visible"
    viewport={viewportOnce}
    variants={fadeUp}
  >
    {eyebrow && <p className="eyebrow">{eyebrow}</p>}
    <h2>{title}</h2>
    {lead && <p className="section__lead">{lead}</p>}
  </motion.div>
);

export default SectionHeader;
